import { ChangeDetectorRef, Component } from '@angular/core';
import { ProductSearchPage } from '@spartacus/core';
import {
  ProductGridItemComponent,
  ProductListComponentService,
  ProductListItemContext,
  ProductListItemContextSource,
  ProductListOutlets,
} from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ProductService } from '../service/product.service';

@Component({
  selector: 'cx-product-grid-item',
  templateUrl: './product-ekgrid-item.component.html',
  styleUrls: ['./product-ekgrid-item.component.scss'],
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
})
export class ProductEkgridItemComponent extends ProductGridItemComponent {
  public model: any;
  model$: Observable<ProductSearchPage> =
    this.productListComponentService.model$;
  readonly ProductListOutlets = ProductListOutlets;
  public product: any;
  public productCode: string | undefined;

  constructor(
    protected productListItemContextSource: ProductListItemContextSource,
    protected productService: ProductService,
    protected productListComponentService: ProductListComponentService,
    protected cd: ChangeDetectorRef
  ) {
    super(productListItemContextSource);
  }
}
